import script from "./PopperActionCustom.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopperActionCustom.vue?vue&type=script&setup=true&lang=ts"

import "./PopperActionCustom.vue?vue&type=style&index=0&id=11be616f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11be616f"]])

export default __exports__